const chatToggleBtn = document.getElementsByClassName('following-chat-btn')[0];
const chatToggleBtnWr = document.getElementsByClassName(
  'btn-following-chat-wr'
)[0];
const chatMenuBtn = document.getElementsByClassName('menu-chat-btn')[0];
const chatModal = document.getElementsByClassName('chat-modal')[0];

let hasChatOpened = false;
let hasUserInteracted = false;

if (chatToggleBtn && chatModal) {
  /*const vh = window.innerHeight * 0.01;*/

  const chatModalClose = chatModal.querySelector('.chat-modal__head-close');
  const chatModalScrollEl = chatModal.querySelector('.chat-modal__scroll');

  const chatInput = chatModal.querySelector(
    '.chat-modal__input-container input'
  );
  const chatTextarea = chatModal.querySelector(
    '.chat-modal__input-container textarea'
  );
  const chatInputBtn = chatModal.querySelector('.chat-modal__input-btn');

  function sendChat() {
    chatInputBtn.click();
  }

  if (chatInput) {
    chatInput.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        sendChat();
      }
    });
  }

  if (chatTextarea) {
    chatTextarea.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        sendChat();
      }
    });
  }

  /*const chatModalHeadEl = chatModal.querySelector('.chat-modal__head');
  const chatModalBottomlEl = chatModal.querySelector('.chat-modal__bottom');
  const headerEl = chatModal.querySelector('header');*/

  window.updateModalBottom = function updateModalBottom() {
    if (chatToggleBtnWr) {
      const cont = chatToggleBtnWr.querySelector('.cont');
      if (cont) {
        const leftOffset = cont.getBoundingClientRect().left;
        const bottomOffset = window.getComputedStyle(chatToggleBtnWr).bottom;
        chatModal.style.right = leftOffset + 'px';
        chatModal.style.bottom = bottomOffset;
      }
    }
  };

  updateModalBottom();
  window.addEventListener('resize', updateModalBottom);

  chatToggleBtn.addEventListener('click', (event) => {
    event.stopPropagation();
    hasChatOpened = true;
    hasUserInteracted = true;
    menuCloseFunc();
    chatModal.classList.remove('is-closed');
    chatModal.classList.toggle('is-active');
    chatToggleBtn.classList.toggle('is-open-chat');

    if (chatToggleBtnWr) {
      updateModalBottom();
    }
  });

  chatModalClose.addEventListener('click', () => {
    hasUserInteracted = true;
    chatModal.classList.add('is-closed');

    setTimeout(function () {
      chatModal.classList.remove('is-active');
      chatToggleBtn.classList.remove('is-open-chat');
    }, 400);

    setTimeout(function () {
      chatModal.classList.remove('is-closed');
    }, 900);
  });

  document.addEventListener('click', (event) => {
    const targetElement = event.target;
    const isChatOpen = chatModal.classList.contains('is-active');

    const isClickInsideProjectDropdown = targetElement.closest(
      '.project-dropdown-btn-content'
    );

    if (
      isChatOpen &&
      !chatModal.contains(targetElement) &&
      targetElement !== chatToggleBtn &&
      targetElement !== chatMenuBtn &&
      !isClickInsideProjectDropdown
    ) {
      hasUserInteracted = true;
      chatModal.classList.remove('is-active');
      chatToggleBtn.classList.remove('is-open-chat');
    }
  });

  chatMenuBtn.addEventListener('click', (event) => {
    hasChatOpened = true;
    hasUserInteracted = true;
    menuCloseFunc();

    setTimeout(() => {
      chatModal.classList.remove('is-closed');
      chatModal.classList.add('is-active');
      chatToggleBtn.classList.add('is-open-chat');

      if (chatToggleBtnWr) {
        updateModalBottom();
      }
    }, 300);
  });

  const chatModalScroll = new SimpleBar(chatModalScrollEl);

  window.scrollToBottom = function scrollToBottom() {
    const scrollContainer = chatModalScroll.getScrollElement();
    if (scrollContainer) {
      const isSmoothScrollSupported =
        'scrollBehavior' in document.documentElement.style;

      if (isSmoothScrollSupported) {
        scrollContainer.scrollTo({
          top: scrollContainer.scrollHeight,
          behavior: 'smooth',
        });
      } else {
        scrollContainer.scrollTop = scrollContainer.scrollHeight;
      }
    }
  };

  if (chatInput) {
    chatInput.addEventListener('change', () => {
      scrollToBottom();
    });
  }

  if (chatTextarea) {
    chatTextarea.addEventListener('change', () => {
      scrollToBottom();
    });
  }

  chatInputBtn.addEventListener('click', () => {
    scrollToBottom();
  });

  const initChatScrollTrigger = () => {
    const textDigitalSec = document.querySelector('.text-digital-sec');
    if (!textDigitalSec || !chatModal) {
      return;
    }

    const portfolioSec = document.querySelector('.portfolio-sec');
    const triggerElement = portfolioSec || textDigitalSec;

    const openChat = () => {
      if (hasChatOpened || hasUserInteracted) {
        return;
      }
      window.chatTimerOpenFunc();
    };

    const scrollTrigger = globalThis.ScrollTrigger;

    if (scrollTrigger && typeof scrollTrigger.create === 'function') {
      scrollTrigger.create({
        trigger: triggerElement,
        start: portfolioSec ? 'top 80%' : 'bottom top',
        once: true,
        onEnter: () => {
          openChat();
        },
      });
      return;
    }

    let ticking = false;
    const checkScroll = () => {
      if (hasChatOpened || hasUserInteracted) {
        window.removeEventListener('scroll', onScroll);
        return;
      }

      const rect = triggerElement.getBoundingClientRect();
      const isPast = portfolioSec
        ? rect.top <= window.innerHeight * 0.8
        : rect.bottom <= 0;

      if (isPast) {
        window.removeEventListener('scroll', onScroll);
        openChat();
      }
    };

    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          checkScroll();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    checkScroll();
  };

  initChatScrollTrigger();
  window.initChatScrollTrigger = initChatScrollTrigger;
}

window.initChatProductToggle = function initChatProductToggle() {
  const productCard = document.getElementsByClassName(
    'chat-bot-message__product'
  )[0];
  if (productCard) {
    const productCardsArr = document.querySelectorAll(
      '.chat-bot-message__product'
    );
    for (let i = 0; i < productCardsArr.length; i++) {
      const input = productCardsArr[i].querySelector('input');

      const counterBlock = productCardsArr[i].querySelector(
        '.counter-parent-toggle'
      );
      const btn = productCardsArr[i].querySelector('.chat-bot-btn');

      if (btn) {
        btn.addEventListener('click', () => {
          if (counterBlock) {
            counterBlock.classList.add('active');
          }

          if (input && input.value < 1) {
            input.stepUp();
          }
        });
      }
    }
  }
};
initChatProductToggle();

window.chatTimerOpenFunc = function chatTimerOpenFunc() {
  const modal = chatModal || document.getElementsByClassName('chat-modal')[0];
  const toggleBtnWr =
    chatToggleBtnWr ||
    document.getElementsByClassName('btn-following-chat-wr')[0];

  if (!modal || hasChatOpened || hasUserInteracted) {
    return;
  }

  hasChatOpened = true;
  modal.classList.remove('is-closed');
  modal.classList.add('is-active');

  if (toggleBtnWr && typeof updateModalBottom === 'function') {
    updateModalBottom();
  }
};
